<template>
  <div
    class="card video-card"
    v-bind:class="dynamicCardClass"
  >
  <div @mouseover="hovering = true"
    @mouseleave="hovering = false"
    v-on:click="selectVideoAsset()">
    <div class="embed-responsive embed-responsive-16by9" >
      <template v-if="videoAsset.mux_asset">
        <img
          v-show="!hovering"
          class="card-img-top embed-responsive-item"
          :src="posterComputed"
          :alt="videoAsset.title"
        />
        <img
          v-show="hovering"
          class="card-img-top embed-responsive-item"
          :src="getGif()"
          :alt="videoAsset.title"
        />
      </template>
      <template v-else>
        <div class="card-img-top embed-responsive-item missing-mux-asset d-flex align-items-center justify-content-center"
        >Video Unavailable</div>
      </template>
      
    </div>
    <div class="card-body video-card-body p-0 pt-3">
      <div class='d-flex flex-row w-100 justify-content-between video-asset-card__header'>
        <h3 class="c-title video-asset-card__title pb-2" >{{ videoAsset.title }}</h3>
        <div :class="{'base-bookmarked': videoAsset.bookmarkable}" class='video-card-bookmark-container base-bookmark' v-on:click.stop="toggleBookmark()">
          <i v-if="!!videoAsset.bookmarkable" class="fas fa-bookmark"></i>
          <i v-show="!videoAsset.bookmarkable" class="fal fa-bookmark"></i>
        </div>
      </div>

        <div class="agenda__item-tags pb-2" v-if="videoAsset.schedule_item_tags">
          <div v-for="(tag, tagIndex) in videoAsset.schedule_item_tags" 
            class="badge tag-badge agenda__item-tag" 
            v-show="tag.visible" 
            :style="`background-color: ${tag.tag_hex};`" 
            :data-tag-id="tag.id" :data-tag-name="tag.tag" :key="tagIndex"
          >
            {{ tag.tag }}
          </div>
        </div>

      <div class="video-asset-viewed mb-2" v-if="videoAsset.track_completion">
        <div class="viewed-status" :class="{ 'viewed': videoAssetCompleted, 'not-viewed': !videoAssetCompleted }">
          <i :class="viewedIconClass"></i>
          <span>{{ viewedStatusText }}</span>
        </div>
      </div>

      <button class="btn btn-primary video-list-watch-btn w-100">Watch Now</button>

      <!-- Video Duration -->
      <video-asset-duration
        :video-asset="videoAsset"
      ></video-asset-duration>
    </div>
    </div>
    <!-- Like session -->
    <div class="agenda__item-likeable-item" v-cloak>
        <likeable-item
          :plugin-type="'VideoAsset'"
          :plugin="videoAsset"
          aria-label="Did you like this video?"
          tabindex="0"
          ></likeable-item>
    </div>
    <!-- /Like session -->
  </div>
</template>

<script>
import { EventBus } from "../EventBus.js";

export default {
  props: ["videoAsset", "videoAssetVideoPlaylist"],

  data: function () {
    return {
      hovering: false,
    };
  },

  methods: {

    toggleBookmark () {
      window.EventBus.$emit('video-asset-bookmarkable-toggle', this.videoAsset);
    },

    getGif() {
      if (this.videoAsset.mux_asset && this.videoAsset.mux_asset.gif){
        return this.videoAsset.mux_asset.gif;
      }
      else {
        return null;
      }
    },

    selectVideoAsset() {
      EventBus.$emit("video-asset-selected", this.videoAsset);
      window.EventBus.$emit(
        "video-asset-video-playlist-selected",
        this.videoAssetVideoPlaylist
      );
    },
  },

  computed: {

    videoAssetCompleted () {
      return this.videoAsset 
        && this.videoAsset.video_asset_completions 
        && this.videoAsset.video_asset_completions.length
    },

    viewedIconClass () {
      return this.videoAssetCompleted 
        ? 'fas fa-check-circle' 
        : 'far fa-circle';
    },

    viewedStatusText() {
      return this.videoAssetCompleted 
        ? 'Viewed' 
        : 'Not viewed';
    },


    dynamicCardClass () {
      return `select-vavp-${this.videoAssetVideoPlaylist.id}`;
    },
    posterComputed() {
      if (this.videoAsset.custom_poster_image_enabled && this.videoAsset.poster_image_url) {
        return this.videoAsset.poster_image_url
      }
      else if(this.videoAsset.mux_asset && this.videoAsset.mux_asset.poster) {
        return this.videoAsset.mux_asset.poster
      }
      else {
        return null;
      }
    },
  }
};
</script>

<style>
.video-card:hover {
  cursor: pointer;
}

.video-asset-card__title {
  margin-top: 0;
}

.customEvent .video-card-duration-container {
  display: none;
}

.viewed-status {
  display: flex;
  align-items: center;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 15px;
}

.viewed-status i {
  margin-right: 8px;
  font-size: 1.2em;
}

.viewed {
  color: #28a745;
}

.not-viewed {
  color: #6c757d;
}

</style>